import { render, staticRenderFns } from "./DatasetMetadataDownload.vue?vue&type=template&id=493d451e&"
import script from "./DatasetMetadataDownload.vue?vue&type=script&lang=js&"
export * from "./DatasetMetadataDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports